import { useEffect, useState } from "react";
import { useParams, Link as RouterLink, useNavigate } from "react-router-dom";
import styles from "./TodayRequestList.module.css";
import { Button, Alert, Snackbar } from "@mui/material";
import { BorderColorOutlined } from "@mui/icons-material";
import axios from "axios";
import { TableLoader } from "../components/ContentLoader";
import { authData } from "../components/GetAuth";

const DriverAddressDetails = () => {
  const bookingId = useParams();
  const auth = authData();
  const navigate = useNavigate();
  const API_TOKEN = auth?.api_token;
  const [contentLoading, setContentLoading] = useState(true);
  const [bookingData, setBookingData] = useState({});
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarType, setSnackbarType] = useState("success");

  useEffect(() => {
    setContentLoading(true);
    axios(process.env.REACT_APP_API_URL + "v1/driver/request-details/" + bookingId?.id, {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`,
      }
    }).then((response) => {
      if (response.data.status === "SUCCESS") {
        setContentLoading(false);
        let bookingDataTemp = response.data.data;
        setBookingData(bookingDataTemp);
      } else {
        setContentLoading(false);
      }
    }).catch((error) => {
      setContentLoading(false);
    });
  }, [API_TOKEN, bookingId]);

  const setBookingUnassign = (bookingid) => {
    axios(process.env.REACT_APP_API_URL + "v1/driver/cancel-bookings/" + bookingid, {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`
      }
    }).then((response) => {
      if (response.data.status === "SUCCESS") {
        setSnackbarOpen(true);
        setSnackbarMessage(response.data.message);
        setSnackbarType("success");
        setTimeout(() => {
          navigate("/driver/today-request-list");
        }, 2000);
      }
    }).catch((error) => { });
  };
  return (<>
    <div className={`${styles.MainDiv}`}>
      <div className={`${styles.PageTitleWrap}`}>
        <p className={`${styles.PageTitle}`}>Request Details</p>
      </div>
      <div className={`${styles.MainCard}`}>
        {contentLoading && <TableLoader />}

        {!contentLoading && (<div className={`${styles.Container}`}>
          <div className={`${styles.CusRow}`}>
            <div className={`${styles.CustomerDeSec}`}>
              <div className={`${styles.UserProCard2}`}>
                <div className={`${styles.UserHead}`}>
                  <p className={`${styles.UserProName}`}>Pickup Address</p>
                  <RouterLink className={`${styles.SideEditBU} `} to={"/driver/address-edit/" + bookingData?.pickup_details?.id}>
                    <BorderColorOutlined />
                  </RouterLink>
                </div>
                <div className={`${styles.UserProDe}`}>
                  <p className={`${styles.UserProDeList}`}>
                    <span>Name</span>
                    {bookingData?.pickup_details?.name}
                  </p>
                  <p className={`${styles.UserProDeList}`}>
                    <span>Address</span>
                    {bookingData?.pickup_details?.address}
                  </p>
                  <p className={`${styles.UserProDeList}`}>
                    <span>Phone Number</span>
                    {bookingData?.pickup_details?.phone}
                  </p>
                  <p className={`${styles.UserProDeList}`}>
                    <span>Postal Code</span>
                    {bookingData?.pickup_details?.post_code}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className={`${styles.CusRow}`}>
            <div className={`${styles.CustomerDeSec}`}>
              <div className={`${styles.UserProCard2}`}>
                <div className={`${styles.UserHead}`}>
                  <p className={`${styles.UserProName}`}>Recipient Address</p>
                </div>
                <div className={`${styles.UserProDe}`}>
                  <p className={`${styles.UserProDeList}`}>
                    <span>Name</span>
                    {bookingData?.recipient_details?.name}
                  </p>
                  <p className={`${styles.UserProDeList}`}>
                    <span>Address:</span>
                    {bookingData?.recipient_details?.address}
                  </p>
                  <p className={`${styles.UserProDeList}`}>
                    <span>Phone Number</span>
                    {bookingData?.recipient_details?.phone}
                  </p>
                  <p className={`${styles.UserProDeList}`}>
                    <span>Postal Code</span>
                    {bookingData?.recipient_details?.post_code}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className={`${styles.StepBUSec}`}>
            <Button onClick={(e) => { setBookingUnassign(bookingData?.id); }} className={`CancelBU`}>Failed to Accept</Button>
            <RouterLink to={`/driver/item-details/${bookingData?.id}`} as={Button} className={`SubmitBU`}>Proceed</RouterLink>
          </div>
        </div>)}
      </div>
    </div>

    <Snackbar
      open={snackbarOpen}
      autoHideDuration={6000}
      onClose={(e) => setSnackbarOpen(false)}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert
        onClose={(e) => setSnackbarOpen(false)}
        severity={snackbarType}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {snackbarMessage}
      </Alert>
    </Snackbar>
  </>
  );
};

export default DriverAddressDetails;